<template>
  <div>
    <div
      class="success-checkmark"
      style="transform: scale(1.5); margin-top: calc(30px + 2rem);"
    >
      <div class="check-icon">
        <span class="icon-line line-tip"></span>
        <span class="icon-line line-long"></span>
        <div class="icon-circle"></div>
        <div class="icon-fix"></div>
      </div>
    </div>
    <div
      class="text-center"
      style="font-weight: bold; font-family: 'Poppins', sans-serif;"
    >
      ¡Listo, gracias!
      <br />Chequea tu mail.
    </div>
  </div>
</template>
<script>
export default {
  mounted(){
    this.$store.dispatch('clearCart');
  }
};
</script>
